import { apiFetch, apiFetchAuth, apiFetchPayment } from '../api/client';

export function fetchPaymentMarket() {
    return apiFetch('/api/market');
}

export function initPayment(productId, returnTo = '') {
    return apiFetchAuth('/payments/init', {
        method: 'POST',
        body: JSON.stringify({ product_id: productId, return_to: returnTo || undefined }),
    });
}

export function confirmPayment(paymentKey, orderId, amount) {
    return apiFetchAuth('/payments/confirm', {
        method: 'POST',
        body: JSON.stringify({ paymentKey, orderId, amount }),
    });
}

export function fetchPaymentEntitlements() {
    return apiFetchAuth('/payments/entitlements');
}

export function unlockChemistryPremium(resultId) {
    return apiFetchAuth('/payments/entitlements/chemistry/unlock', {
        method: 'POST',
        body: JSON.stringify({ result_id: String(resultId || '') }),
    });
}

export function loadTossPaymentsScript() {
    if (window.TossPayments) {
        return Promise.resolve(window.TossPayments);
    }

    return new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-toss-payments-script="true"]');
        if (existing) {
            existing.addEventListener('load', () => resolve(window.TossPayments), { once: true });
            existing.addEventListener('error', () => reject(new Error('Failed to load Toss Payments script')), { once: true });
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://js.tosspayments.com/v2/standard';
        script.async = true;
        script.dataset.tossPaymentsScript = 'true';
        script.onload = () => resolve(window.TossPayments);
        script.onerror = () => reject(new Error('Failed to load Toss Payments script'));
        document.body.appendChild(script);
    });
}


export function fetchGuestResultUnlock(resultId) {
    return apiFetchPayment(`/payments/guest/results/${encodeURIComponent(String(resultId || ''))}`);
}

export function fetchLatestGuestChemistryResult() {
    return apiFetchPayment('/payments/guest/chemistry/latest');
}
